import { Injectable } from '@angular/core';
import { InvocaService } from './invoca.service';
import { DateUtils } from '../tools/utils/date.utils';

@Injectable()
export class PortalService {
    date_utils = new DateUtils();

    constructor(private invoke: InvocaService) {}

    /**
     * Obtiene los avisos (alertas) del Portal por el cual ingreso
     */
    async get_avisos(): Promise<any> {
        try {
            let _avisos = await this.invoke.httpInvoke('base/getAvisos', null);

            let avisos = [];

            for (let i = 0; i < _avisos.length; i++) {
                let r = _avisos[i];

                let data_aviso = r.mensaje.split('<CORTE>');
                let mensaje = data_aviso[2],
                    more = data_aviso[2];
                if (data_aviso[2].length > 100)
                    mensaje = data_aviso[2].substr(0, 100) + '...';

                let _fecha_number = r.fecha.split('/');
                let fn = parseInt(
                    _fecha_number[2] +
                        '' +
                        _fecha_number[1] +
                        '' +
                        _fecha_number[0]
                );

                avisos.push({
                    flag: i,
                    nombre: data_aviso[1],
                    anuncio: mensaje,
                    anuncio_completo: more,
                    fecha: this.date_utils.parseJSONtoDate(
                        this.date_utils.getNumberToJSON(fn)
                    ),
                });
            }

            return avisos;
        } catch (error) {
            return [];
        }
    }

    /**
     * Obtiene la url del modulo al cual viajar (se conserva el token)
     * @param idProyecto
     * @param codModulo
     */
    async gotoModule(params?: any): Promise<any> {
        let data = await this.invoke.httpInvoke('base/navigate', params);
        window.location.replace(data.url);
    }

    /**
     * Obtiene la url de la aplicacion al cual viajar (crea un nuevo token en redis)
     * @param idProyecto
     */
    async gotoApp(params?: any): Promise<any> {
        let data = await this.invoke.httpInvoke('base/navigateApp', params);
        window.location.replace(data.url);
    }

    /**
     * Obtiene la url de la aplicacion por donde ingreso al modulo (se conserva el token)
     * @param idProyecto
     */
    async backToPortal(params?: any): Promise<any> {
        let data = await this.invoke.httpInvoke('base/getAppUrl', params);
        window.location.replace(data.url);
    }

    /**
     * Envia un correo de contacto a soporte@uv.cl
     */
    async sendContactMail(params?: any): Promise<any> {
        await this.invoke.httpInvoke('base/sendMail', params);
    }
}
